import React, { useMemo, useEffect, useState } from "react";
import Breadcrumbs from '../../../Components/Common/Breadcrumb';
import TableContainer from '../../../Components/Common/TableContainer';
import { subscribeToTokenRefresh } from "../../../helpers/Refreshfile";

import axios from "axios";
import { Alert, Row, Col, Card, CardBody, Modal, ModalHeader, Label, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import classnames from "classnames";
import defaultUserImg from "../../../assets/images/defaultuserimgdark.png"
const baseUrl = process.env.REACT_APP_BASE_URL;

interface column {
  header: string;
  accessorKey?: string;
  accessorFn?: (row: any) => string;
  enableColumnFilter: boolean;
  enableSorting: boolean;
  cell?: (info: any) => React.ReactNode;
}


const Cbookings = () => {

  const [alertMsgg, setAlertMsgg] = useState<any>({ open: false, type: "success", content: 'Messages here.', time: '2500' });
  const handleAlertMsggClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === "clickaway") { return; }
    setAlertMsgg({ ...alertMsgg, open: false })
  };
  const [showloader, setshowloader] = useState(true);




  const [modal_center, setmodal_center] = useState(false);
  const [modal_center_delete, set_delete_delete] = useState(false);
  const [edit_modal_center, setmodal_center_edit] = useState(false);
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [deleteId, setDeleteId] = useState<string | null>(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [errors, setErrors] = useState({ email: "", phone: "" });
  const [categories, setCategories] = useState<any>([]);
  const [subcategories, setSubcategories] = useState<Subcategory[]>([]);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedSubcategory, setSelectedSubcategory] = useState('');
  const [expertFormTitle, setExpertFormTitle] = useState<string>('Add Expert');
  const [rows, setRows] = useState([]);
  const [bookings, setBookings] = useState<any[]>([]);
  const [timezone, setTimeZone] = useState<any[]>([]);
  const [timecode, setTimeCode] = useState<any[]>([]);
  const [selectedTimezone, setSelectedTimezone] = useState('');
  const [selectedCode, setSelectedCode] = useState('');
  const [filteredTimezones, setFilteredTimezones] = useState<any[]>([]);
  const [modal_view_expert, setmodal_view_expert] = useState(false);
  const [selectedExpertForView, setSelectedExpertForView] = useState<any | null>(null);
  const [activeViewTab, setActiveViewTab] = useState<string>("1");

  const [checkingStripe, setCheckingStripe] = useState<Record<string, boolean>>({});
  const [stripeCheckResults, setStripeCheckResults] = useState<Record<string, any>>({});

  function removeBodyCss() {
    document.body.classList.add("no_padding");
  }
  function addExpert() {
    setSelectedExpert({
      first_name: '',
      last_name: '',
      email: '',
      phone: '',
      category: '',
      subcategory: '',
      image: null,
      id: null,
      timezone: '',
      timecode: '',
      share_percentage: 0,
    });
    setSelectedTimezone('');
    setSelectedCode('');

    setSelectedImage(null);
    setError({
      first_name: '',
      last_name: '',
      email: '',
      phone: '',
      category: '',
      subcategory: '',
      selectedTimezone: '',
      selectedCode: ''

    });
    setmodal_center(true); // or toggle as you like
    removeBodyCss();
  }
  function deleteExpert(id?: string) {
    if (id !== undefined) {
      setDeleteId(id);
    }
    set_delete_delete(!modal_center_delete);
    removeBodyCss();
  }
  function editExpert(expert?: any) {

    if (expert) {
      const expertTimezone = expert?.timezone || '';
      const expertCountryCode = expert?.country_code || '';
      
      setSelectedExpert({
        first_name: expert.user?.first_name || '',
        last_name: expert.user?.last_name || '',
        email: expert.user?.email || '',
        phone: expert.user?.phone || '',
        // category: categories.filter((cat:any)=>(cat.id == expert.category))[0],
        category: expert.basic_cat[0],
        subcategory: expert.basic_cat[1],
        image: expert?.user?.profile_pic || null,
        id: expert.id || null,
        timezone: expertTimezone,
        timecode: expertCountryCode,
        share_percentage: expert?.share_percentage || 0,
      });
      
      // Set state variables from expert data
      setSelectedTimezone(expertTimezone);
      setSelectedCode(expertCountryCode);
      
      // Filter timezones if country code exists
      if (expertCountryCode && timezone.length > 0) {
        const filtered = timezone.filter((item: any) => item.code === expertCountryCode);
        setFilteredTimezones(filtered);
      } else if (timezone.length > 0) {
        setFilteredTimezones(timezone);
      }

      setSelectedImage(expert?.user?.profile_pic || null);
    } else {
      setSelectedExpert({
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        category: categories[0]?.name || '',
        subcategory: subcategories[0]?.name || '',
        image: null,
        id: null,
        timezone: '',
        timecode: '',
        share_percentage: 0,
      });
      setSelectedImage(null);

    }
    setError({
      first_name: '',
      last_name: '',
      email: '',
      phone: '',
      category: '',
      subcategory: '',
      selectedTimezone: '',
      selectedCode: ''
    });

    setmodal_center_edit(true);
    removeBodyCss();
  }

  function viewExpert(expert?: any) {
    console.log("viewExpert called with expert:", expert);
    if (expert) {
      console.log("Setting expert and opening modal");
      setSelectedExpertForView(expert);
      setmodal_view_expert(true);
      console.log("Modal state should be true now");
      removeBodyCss();
      
      // Fetch full expert details
      const fetchFullExpertDetails = async () => {
        try {
          setshowloader(true);
          const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/accounts/adm_expert_listings`, 
            { expid: expert.id, full_details: true }, 
            { withCredentials: true }
          );
          if (response.status === 'SENT' && response.exps && response.exps.length > 0) {
            setSelectedExpertForView(response.exps[0]);
          }
          setshowloader(false);
        } catch (error: any) {
          console.error('Error fetching full expert details:', error);
          setshowloader(false);
        }
      };
      fetchFullExpertDetails();
    } else {
      console.log("Expert is undefined");
    }
  }

  function closeViewExpert() {
    setmodal_view_expert(false);
    setSelectedExpertForView(null);
    setActiveViewTab("1");
    removeBodyCss();
  }




  const validateEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validatePhone = (phone: string) => {
    const phoneRegex = /^\+?[0-9]{1,3}?[0-9]{9}$/; // Allows country code + 10 digits
    return phoneRegex.test(phone);
  };


  const handleChange = (field: any, value: any) => {
    setSelectedExpert((prev: any) => ({ ...prev, [field]: value }));
    setErrors((prev: any) => ({
      ...prev,
      [field]:
        field === "email"
          ? validateEmail(value)
            ? ""
            : "Invalid email format"
          : field === "phone"
            ? validatePhone(value)
              ? ""
              : "Enter a valid 10-digit phone number"
            : prev[field],
    }));
  };

  const handleConfirmDelete = () => {
    console.log('handleConfirmDelete k ander h ', deleteId)
    if (deleteId !== null) {
      const createexp = async () => {
        try {
          setshowloader(true)
          const response = await axios.post(`/accounts/exp_pro_create`, { 'todelete': true, 'eid': deleteId }, { withCredentials: true, headers: { 'Content-Type': 'application/json', }, });
          if (response.status === "DONE") {
            setAlertMsgg({ ...alertMsgg, open: true, content: "Expert deleted successfuly!", type: "success" })
            setTimeout(() => {
              setAlertMsgg({ ...alertMsgg, open: false, content: "", type: "" });
            }, 4000);
            setshowloader(false);
            fetch_bookings()
            // setRows(rows.filter((row) => row.id !== deleteId));
          }
        } catch (error: any) {
          if (error.response) {
            if ([401, 422].includes(error.response.status)) {
              console.log('Error in stripe payment')
              setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
            }
            else if (error.response.status === 403) {
              console.log('Error stripe payment')
              setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
              setTimeout(() => { window.location.href = "/logout" }, 2000)
            } else {
              console.log('An error occurred')
              setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
            }
          } else {
            console.log('An error occurred')
            setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
          }
          setshowloader(false)
        }
      };
      createexp();
    }
    setDeleteDialogOpen(false);
    setDeleteId(null);
  };


  const checkExpertStripeMode = async (expertPublicId: string, strpProdId: string | null | undefined) => {
    if (!strpProdId) {
      setAlertMsgg({ ...alertMsgg, open: true, content: "Expert has no Stripe product ID yet (created on first paid booking).", type: "error" });
      return;
    }
    const key = `expert_${expertPublicId}`;
    setCheckingStripe((prev) => ({ ...prev, [key]: true }));
    try {
      const { data } = await axios.post(
        "/payments/stripe_mode_check/",
        { stripe_id: strpProdId, object_type: "product" },
        { withCredentials: true }
      );
      if (data?.status === "CHECKED" && data.results) {
        setStripeCheckResults((prev) => ({ ...prev, [key]: data.results }));
      } else {
        setAlertMsgg({ ...alertMsgg, open: true, content: "Unexpected response from Stripe check", type: "error" });
      }
    } catch (error: any) {
      if (error.response?.data?.error) {
        setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
      } else {
        setAlertMsgg({ ...alertMsgg, open: true, content: "Error checking Stripe mode", type: "error" });
      }
    } finally {
      setCheckingStripe((prev) => ({ ...prev, [key]: false }));
    }
  };

  const moveExpertProductToLive = async (expertPublicId: string) => {
    try {
      setshowloader(true);
      const { data } = await axios.post(
        "/payments/move_expert_product_to_live/",
        { expert_id: expertPublicId },
        { withCredentials: true }
      );
      if (data?.status === "MOVED_TO_LIVE") {
        let message = data.message || "Moved to live";
        if (data.results?.product) {
          message += `\nProduct: ${data.results.product.old_id} → ${data.results.product.new_id}`;
        }
        setAlertMsgg({ ...alertMsgg, open: true, content: message, type: "success" });
        fetch_bookings();
        const key = `expert_${expertPublicId}`;
        setStripeCheckResults((prev) => {
          const next = { ...prev };
          delete next[key];
          return next;
        });
      } else if (data?.error) {
        setAlertMsgg({ ...alertMsgg, open: true, content: data.error, type: "error" });
      }
    } catch (error: any) {
      setAlertMsgg({
        ...alertMsgg,
        open: true,
        content: error.response?.data?.error || "Error moving expert product to Live",
        type: "error",
      });
    } finally {
      setshowloader(false);
    }
  };

  const moveExpertProductToTest = async (expertPublicId: string) => {
    try {
      setshowloader(true);
      const { data } = await axios.post(
        "/payments/move_expert_product_to_test/",
        { expert_id: expertPublicId },
        { withCredentials: true }
      );
      if (data?.status === "MOVED_TO_TEST") {
        let message = data.message || "Moved to test";
        if (data.results?.product) {
          message += `\nProduct: ${data.results.product.old_id} → ${data.results.product.new_id}`;
        }
        setAlertMsgg({ ...alertMsgg, open: true, content: message, type: "success" });
        fetch_bookings();
        const key = `expert_${expertPublicId}`;
        setStripeCheckResults((prev) => {
          const next = { ...prev };
          delete next[key];
          return next;
        });
      } else if (data?.error) {
        setAlertMsgg({ ...alertMsgg, open: true, content: data.error, type: "error" });
      }
    } catch (error: any) {
      setAlertMsgg({
        ...alertMsgg,
        open: true,
        content: error.response?.data?.error || "Error moving expert product to Test",
        type: "error",
      });
    } finally {
      setshowloader(false);
    }
  };

  const renderExpertStripeCheckResult = (expertPublicId: string) => {
    const key = `expert_${expertPublicId}`;
    const result = stripeCheckResults[key];
    if (!result) return null;
    const existsInTest = result.exists_in_test;
    const existsInLive = result.exists_in_live;
    let modeSummary = result.mode_summary || "";
    if (!modeSummary) {
      if (existsInTest && existsInLive) modeSummary = "EXISTS IN BOTH TEST AND LIVE";
      else if (existsInTest) modeSummary = "TEST MODE ONLY";
      else if (existsInLive) modeSummary = "LIVE MODE ONLY";
      else modeSummary = "NOT FOUND IN EITHER MODE";
    }
    return (
      <div
        style={{
          marginTop: 8,
          padding: 12,
          background: "#f5f5f5",
          borderRadius: 8,
          fontSize: 12,
          border: "1px solid #e0e0e0",
        }}
      >
        <div style={{ fontWeight: 600, marginBottom: 6, color: "#222" }}>{modeSummary}</div>
        <div style={{ fontSize: 11, color: "#666", marginBottom: 4 }}>
          Product: {existsInTest && <span style={{ color: "#f57c00" }}>TEST</span>}
          {existsInTest && existsInLive && <span> + </span>}
          {existsInLive && <span style={{ color: "#388e3c" }}>LIVE</span>}
        </div>
        {modeSummary === "TEST MODE ONLY" && (
          <button
            type="button"
            className="btn btn-sm btn-warning mt-2"
            onClick={() => moveExpertProductToLive(expertPublicId)}
            style={{ fontSize: 11, padding: "4px 12px" }}
          >
            <i className="bx bx-transfer" style={{ marginRight: 4 }}></i>
            Move to Live
          </button>
        )}
        {modeSummary === "LIVE MODE ONLY" && (
          <button
            type="button"
            className="btn btn-sm btn-info mt-2"
            onClick={() => moveExpertProductToTest(expertPublicId)}
            style={{ fontSize: 11, padding: "4px 12px" }}
          >
            <i className="bx bx-transfer" style={{ marginRight: 4 }}></i>
            Move to Test
          </button>
        )}
      </div>
    );
  };

  const columns: column[] = useMemo(
    () => [
      {
        header: 'Sr no.',
        enableColumnFilter: false,
        enableSorting: false,
        cell: ({ row, table }) => {
          return row.index + 1;
        },
      },
      {
        header: 'Expert Info',
        accessorFn: (row: any) => {
          const first_name = row?.user?.first_name || '';
          const email = row?.user?.email || '';
          return `${first_name} ${email}`;
        },
        enableColumnFilter: false,
        enableSorting: true,
        cell: (info: any) => {
          const row = info.row.original;
          const first_name = row?.user?.first_name;
          const email = row?.user?.email;
          const attachment = row?.user?.profile_pic;
          return (
            <div className="d-flex align-items-center">
              {attachment ? (
                <img
                  src={`${process.env.REACT_APP_BASE_URL}${attachment}`}
                  alt="User"
                  width="40"
                  height="40"
                  className="rounded-circle object-fit-cover"
                  style={{ marginRight: '10px' }}
                  onError={(e) => {
                    const target = e.target as HTMLImageElement;
                    target.onerror = null;
                    target.src = defaultUserImg;
                  }}
                />
              ) : (
                <img
                  src={defaultUserImg}
                  alt="Default User"
                  width="40"
                  height="40"
                  className="rounded-circle object-fit-cover"
                  style={{ marginRight: '10px' }}
                />
              )}
              <div>
                <p className="mb-0 fw-medium">{first_name || "No first name"}</p>
                <p className="font-size-12 mb-0">{email || "No email"}</p>
              </div>
            </div>
          );
        }
      },
      {
        header: 'Phone',
        accessorFn: (row: any) => row?.user?.phone || "N/A",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Category',
        accessorFn: (row: any) => row?.basic_cat?.join(', ') || 'N/A',
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }: any) => {
          const basicCats = row.original.basic_cat;
          if (!basicCats || basicCats.length === 0) {
            return 'No categories';
          }
          
          // Helper function to capitalize text
          const capitalize = (text: string) => {
            if (!text) return '';
            return text
              .split(' ')
              .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
              .join(' ');
          };
          
          const category = capitalize(basicCats[0] || '');
          const subcategory = capitalize(basicCats[1] || '');
          
          if (category && subcategory) {
            return `${category} (${subcategory})`;
          } else if (category) {
            return category;
          }
          return 'No categories';
        },
      },
      {
        header: 'Revenue Share %',
        accessorFn: (row: any) => row?.share_percentage || 0,
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }: any) => {
          const sharePercentage = row.original.share_percentage || 0;
          return (
            <span className="fw-medium">
              {parseFloat(sharePercentage).toFixed(2)}%
            </span>
          );
        },
      },
      {
        header: 'Status',
        accessorFn: (row: any) => (row?.user?.is_active ? "Active" : "Inactive"),
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }: any) => {
          const isActive = row.original.user?.is_active;
          const id = row.original.id;
          return (
            <div className="d-flex align-items-center gap-2">
              <div className={`fw-medium font-size-12 ${isActive ? 'text-success' : 'text-danger'}`}>
                {isActive ? 'Active' : 'Inactive'}
              </div>
              <div className="form-check form-switch m-0">
                <input type="checkbox" color="success" className="form-check-input" id="customSwitchsizesm" checked={isActive}
                  onChange={() => handleToggle(id)} />
                {/* <input className="form-check-input" type="checkbox" role="switch" checked={isActive}
                          onChange={() => handleToggle(id)}/> */}
              </div>
            </div>
          );
        },
      },

      {
        header: 'Action',
        accessorFn: (row: any) => row.id,
        enableColumnFilter: false,
        enableSorting: false,
        cell: ({ row }: any) => {
          const id = row.original.id;
          const strpProdId = row.original.strp_prod_id;
          const stripeKey = `expert_${id}`;
          return (
            <div className="d-flex flex-column gap-1 flex-wrap">
              <div className="d-flex gap-2 flex-wrap">
                <button
                  className="btn btn-info btn-sm"
                  title="Click to View"
                  onClick={() => { viewExpert(row.original); }}
                >
                  <i className="bx bx-show me-1"></i>
                  View
                </button>
                <button
                  className="btn btn-dark btn-sm"
                  onClick={() => { editExpert(row.original); }}
                >
                  <i className="bx bxs-pencil me-1"></i>
                  Edit
                </button>
                {(row.original.can_delete) ? (
                  <button
                    className="btn btn-danger btn-sm"
                    onClick={() => { deleteExpert(id); }}  // Trigger delete action
                  >
                    <i className="bx bxs-trash-alt me-1"></i>
                    Delete
                  </button>
                ) : null}
              </div>
              {strpProdId ? (
                <div className="mt-1">
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    onClick={() => checkExpertStripeMode(id, strpProdId)}
                    disabled={checkingStripe[stripeKey]}
                    style={{ fontSize: 11, padding: "4px 12px" }}
                  >
                    <i className="bx bx-search" style={{ marginRight: 4 }}></i>
                    {checkingStripe[stripeKey] ? "Checking..." : "Check Stripe"}
                  </button>
                  {renderExpertStripeCheckResult(id)}
                </div>
              ) : null}
            </div>
          );
        },
      },
    ],
    [stripeCheckResults, checkingStripe, alertMsgg]
  );

  interface Category {
    id: number;
    name: string;
    subcats: Array<{ name: string }>
  }

  interface Subcategory {
    id?: number;
    name: string;
  }
  
  const fetch_bookings = async () => {
    try {
      setshowloader(true)
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/accounts/adm_expert_listings`, {}, { withCredentials: true, });
      if (response.status === 'SENT') {
        setshowloader(false)
        
        setBookings(response.exps);
        setCategories(response.categories);
        setSubcategories(response.categories[0]?.subcats || []);

        if (response.exps.length > 0) {
          const expert = response.exps[0];
          const categoryObj = response.categories.find(cat => cat.id === expert.category);
          const subcatObj = categoryObj?.subcats.find(sub => sub.id === expert.subcategory);
          
          setSelectedExpert({
            ...expert,
            category: categoryObj?.name || '',
            subcategory: subcatObj?.name || '',
          });

          setSelectedTimezone(expert.timezone);
          setSelectedCode(expert.timecode);
        }
        
      }
    }
    catch (error: any) {
      console.error('error in fetch_bookings', error)
      if (error.response) {
        if ([401, 422].includes(error.response.status)) {
          console.log('Error in stripe payment')
          setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
        }
        else if (error.response.status === 403) {
          console.log('Error stripe payment')
          setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
          setTimeout(() => { window.location.href = "/logout" }, 2000)
        } else {
          console.log('An error occurred')
          setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
        }
      } else {
        console.log('An error occurred')
        setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
      }
      setshowloader(false)
    }
  };

  const handleCategoryChange = (e: any) => {
    const selectedCategorySet = categories.find((category) => category.name === e.target.value);
    if (selectedCategorySet) {
      setSelectedExpert({
        ...selectedExpert,
        category: e.target.value,
        subcategory: selectedCategorySet?.subcats[0]?.name, // Reset subcategory when category changes
      });
      setSubcategories(selectedCategorySet.subcats || []);
      // Set to first subcategory if available
      // setSelectedSubcategory(selectedCategory.subcats[0]?.name || '');
    } else {
      setSubcategories([]);
      setSelectedSubcategory('');
    }
  };


  const handleSubcategoryChange = (e) => {
    const selectedSubcategoryName = e.target.value;
    console.log('handleSubcategoryChange', selectedSubcategoryName)
    setSelectedSubcategory(selectedSubcategoryName);


    setSelectedExpert({
      ...selectedExpert,
      subcategory: selectedSubcategoryName,
    });

  };


  const handleImageChangeo = (e: any) => {
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const imageDataUrl = reader.result as string;

        // 1. Set image in expert object
        setSelectedExpert((prevState: any) => ({
          ...prevState,
          image: imageDataUrl,
        }));

        // 2. Set image for preview if you're showing it separately
        setSelectedImage(imageDataUrl);
      };
      reader.readAsDataURL(file);
    }
  };


  const isFormValid = () => {
    // const { first_name = '', last_name = '', email = '', phone = '', category = '', subcategory = '' } = selectedExpert || {};
    const { first_name = '', last_name = '', email = '', phone = '' } = selectedExpert || {};

    return (
      first_name.trim() &&
      last_name.trim() &&
      email.trim() &&
      phone.trim()
    );
  };

  type Expert = {
    first_name: string;
    last_name: string;
    email: string;
    phone: string;
    category: string;
    subcategory: string;
    image: string | File | null;
    id: string | null;
    timezone: string;
    timecode: string;
    share_percentage: number;
  };

  const [selectedExpert, setSelectedExpert] = useState<Expert>({
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    category: '',
    subcategory: '',
    image: null,
    id: null,
    timezone: '',
    timecode: '',
    share_percentage: 0,
  });

  const selectRef = React.useRef<HTMLSelectElement>(null);

  const [error, setError] = useState({
    first_name: '', last_name: '', email: '', phone
      : '', category: '', subcategory: '', selectedTimezone: '', selectedCode: ''
  })

  const handleSave = async () => {
    console.log('selectedExpert-----', selectedExpert);
    console.log('selectedExpert-----', selectedExpert.image);
    const currentCategory = selectRef.current?.value;


    const newErrors: any = {};
    if (!selectedExpert.first_name) newErrors.first_name = "First name is required!"
    if (!selectedExpert.last_name) newErrors.last_name = "Last Name is required!"
    if (!selectedExpert.phone) { newErrors.phone = "Phone number is required!" }
    else if (!validatePhone(selectedExpert.phone)) {
      newErrors.phone = "Enter a valid phone number!";
    }
    if (!selectedExpert.email) { newErrors.email = "Email is required!" }
    else if (!validateEmail(selectedExpert.email)) {
      newErrors.email = "Invalid email format!";
    }
    if (!selectedExpert.category || selectedExpert.category.length === 0) {
      newErrors.category = "Please select at least one Category!";
    }
    if (!selectedExpert.subcategory || selectedExpert.subcategory.length === 0) {
      newErrors.subcategory = "Please select at least one Subcategory!";
    }
    if (!selectedTimezone || selectedTimezone.length === 0) {
      newErrors.selectedTimezone = "Please select at least one Timezone!";
    }
    if (!selectedCode || selectedCode.length === 0) {
      newErrors.selectedCode = "Please select at least one Country code!";
    }


    if (Object.keys(newErrors).length > 0) {
      setError(newErrors)
      return
    }


    const openloader = document.querySelector('.loaderWeb') as HTMLElement | null;
    if (openloader) { openloader.style.display = 'flex'; }

    let data = new FormData();
    data.append('first_name', selectedExpert.first_name);
    data.append('last_name', selectedExpert.last_name);
    data.append('email', selectedExpert.email);
    data.append('phone', selectedExpert.phone);
    data.append('cat', selectedExpert.category);
    data.append('subcat', selectedExpert.subcategory);
    data.append('timezone', selectedTimezone);
    data.append('timecode', selectedCode);
    data.append('share_percentage', selectedExpert.share_percentage?.toString() || '0');

    if (selectedExpert.id !== null && selectedExpert.id !== undefined) {
      data.append('eid', selectedExpert.id.toString());
    }

    if (selectedExpert.image) {
      console.log('image in ', selectedExpert.image)
      if (typeof selectedExpert.image === 'string' && selectedExpert.image?.startsWith('data:image')) {
        const response = await fetch(selectedExpert.image);
        const blob = await response.blob();
        const file = new File([blob], 'profile.jpg', { type: blob.type });

        data.append('profile_pic', file);
      }
      else {
        data.append('profile_pic', selectedExpert.image);
      }
    }
    console.log('check whole data ', data)

    try {
      setshowloader(true)
      const response = await axios.post(`/accounts/exp_pro_create`, data, { headers: { "Content-Type": "multipart/form-data" }, withCredentials: true });
      // const parsed = JSON.parse(response); // turns string → object
      // console.log("ye------------",parsed.status); // "DONE"
      // console.log("type of----------",typeof response);
      if (response.status === "DONE") {
        fetch_bookings();
        setAlertMsgg({ ...alertMsgg, open: true, content: selectedExpert.id ? "Expert are updated successfuly!" : "Expert created successfully", type: "success" })
        setshowloader(false)
        const closeloader = document.querySelector('.loaderWeb') as HTMLElement | null;
        if (closeloader) { closeloader.style.display = 'none'; }
        setTimeout(() => {
          setAlertMsgg((prev) => ({
            ...prev,
            open: false
          }));
        }, 4000);
        setmodal_center(false);
        setmodal_center_edit(false);

      }
      setModalOpen(false);
    } catch (error: any) {
      if (error.response) {
        if ([401, 422].includes(error.response.status)) {
          console.log('Error in stripe payment', error.response.error, error.response)
          setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
        }
        else if (error.response.status === 403) {
          console.log('Error stripe payment')
          setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
          setTimeout(() => { window.location.href = "/logout" }, 2000)
        } else {
          console.log('An error occurred')
          setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
        }
      } else {
        console.log('An error occurred')
        setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
      }
      setshowloader(false)
    }
  };

  useEffect(() => {
    fetch_bookings();
    subscribeToTokenRefresh(() => {
      console.log("🔁 Token refreshed. Re-fetching experts...");
      fetch_bookings();
    });
  }, []);

  useEffect(() => { }, [bookings]);

  const handleEditModalClose = () => {
    setmodal_center(false);
    setmodal_center_edit(false);

  };


  const fetch_timezone = async () => {
    try {
      setshowloader(true)
      const response = await axios.post(`/accounts/all_timezone`);
      if (response.status === "SENT") {
        const all_timezones = response.all_timezone;
        setshowloader(false)
        const timezoneObj = all_timezones.map((item: any, index: number) => ({
          id: item.id,
          code: item.code,
          country: item.country,
          timezone: item.timezone
        }));
        const codes = [...new Set(all_timezones.map((item: any) => item.code))];

        setTimeZone(timezoneObj);
        setTimeCode(codes);

      }
    } catch (error: any) {
      if (error.response) {
        if ([401, 422].includes(error.response.status)) {
          console.log('Error in stripe payment')
          setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
        }
        else if (error.response.status === 403) {
          console.log('Error stripe payment')
          setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
          setTimeout(() => { window.location.href = "/logout" }, 2000)
        } else {
          console.log('An error occurred')
          setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
        }
      } else {
        console.log('An error occurred')
        setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
      }
      setshowloader(false)
    }
  }

  useEffect(() => {
    fetch_timezone();
  }, []);

  const handleCountryChange = (e: any) => {
    const code = e.target.value;
    setTimeCode(code);
    setSelectedTimezone('');
    setSelectedCode(code);
    const tzFiltered = timezone.filter((tz) => tz.code === code);
    setFilteredTimezones(tzFiltered);
  };

  const handleTimezoneChange = (e: any) => {
    const tz = e.target.value;
    setSelectedTimezone(tz);
  };

  useEffect(() => {
    if (selectedExpert.timecode) {
      const filtered = timezone.filter((item) => item.code === selectedExpert.timecode);
      setFilteredTimezones(filtered);
    }
  }, [selectedExpert.timecode, timezone]);



  const handleToggle = (id: string) => {
    const createexp = async () => {
      try {
        setshowloader(true)
        const response = await axios.post(`/accounts/user_active_change`, { role: 'exp', eid: id },
          {
            withCredentials: true, headers: { 'Content-Type': 'application/json' },
          }
        );
        if (response.status === "DONE") {
          setshowloader(false)
          //   setAlertMsgg({ ...alertMsgg, open: true, content: "User status updated successfully!", type: "success" });
          setBookings((prev) =>
            prev.map((row: any) =>
              row.id === id ? { ...row, user: { ...row.user, is_active: !row.user.is_active } } : row)
          );


        }
      } catch (error: any) {
        if (error.response) {
          if ([401, 422].includes(error.response.status)) {
            console.log('Error in stripe payment')
            setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
          }
          else if (error.response.status === 403) {
            console.log('Error stripe payment')
            setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
            setTimeout(() => { window.location.href = "/logout" }, 2000)
          } else {
            console.log('An error occurred')
            setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
          }
        } else {
          console.log('An error occurred')
          setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
        }
        setshowloader(false)
      }
    };
    createexp();
  };


  //meta title
  document.title = "Experts | BizServe";

  return (

    <div className="page-content">

      <div className="container-fluid">
        <Breadcrumbs title="Experts" breadcrumbItem="All Experts" />
        {alertMsgg.open && (
          <Alert
            color={alertMsgg.type === "success" ? "success" : "danger"}
            toggle={handleAlertMsggClose}
            fade={false}
            style={{ fontWeight: "bold" }}
          >
            {alertMsgg.content}
          </Alert>
        )}
        <div className="loaderContainer" hidden={!showloader}>
          <div className="spinner">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
        <Row>
          <Col md={12}>
            <div className="d-flex justify-content-end">
              <button className="btn btn-primary mb-3" onClick={() => { addExpert(); }}>+ Add Expert</button>
            </div>
            <Card className="rounded-4 border">
              <CardBody>
                <TableContainer
                  columns={columns}
                  data={bookings || []}
                  isGlobalFilter={true}
                  isPagination={true}
                  SearchPlaceholder="Search By Name..."
                  pagination="pagination"
                  paginationWrapper='dataTables_paginate paging_simple_numbers'
                  tableClass="table-bordered dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Modal
          isOpen={modal_center}
          toggle={() => {
            addExpert();
          }}
          backdrop={'static'}
          id="staticBackdrop"
          centered
          size="lg"
          className="rounded-4">
          <ModalHeader className="py-3 px-4" toggle={() => { handleEditModalClose(); }}>
            <div className="modal-title mt-0 font-size-20 text-dark">Add Expert</div>
          </ModalHeader>
          {alertMsgg.open && (
            <Alert
              color={alertMsgg.type === "success" ? "success" : "danger"}
              toggle={handleAlertMsggClose}
              fade={false}
              style={{ fontWeight: "bold" }}
            >
              {alertMsgg.content}
            </Alert>
          )}
          <div className="modal-body p-4">
            <Row>
              <Col lg={12}>
                <div className="mb-3 border-bottom pb-3 text-center">


                  <div className="text-center mb-2">
                    <div className="position-relative d-inline-block">
                      <div className="position-relative bottom-0 end-0">
                        <Label htmlFor="project-image-input" className="mb-0 position-relative" id="projectImageInput">
                          <div className="avatar-xs imageChangeFloat">
                            <div className="avatar-title bg-light border rounded-circle text-muted cursor-pointer shadow font-size-16">
                              <i className="bx bxs-image-alt"></i>
                            </div>
                          </div>
                          <div className="avatar-lg">
                            <div className="avatar-title bg-light rounded-circle">
                              <img src={selectedImage || defaultUserImg} id="projectlogo-img" alt="" className="avatar-md  rounded-circle object-fit-cover" />
                            </div>
                          </div>
                        </Label>
                        <input className="form-control d-none" id="project-image-input" type="file" accept="image/png, image/gif, image/jpeg" onChange={handleImageChangeo} />
                      </div>

                    </div>
                  </div>
                  <Label className="form-label ">Expert Image</Label>
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3">
                  <label className="form-label">First Name<span className="text-danger px-1">*</span></label>
                  <input
                    // className="form-control"
                    className={`form-control ${error.first_name ? 'is-invalid' : ''}`}
                    type="text"
                    placeholder="First Name"
                    value={selectedExpert.first_name}
                    onChange={(e) => {
                      setSelectedExpert(prev => ({ ...prev, first_name: e.target.value }));
                      setError((prev) => ({ ...prev, first_name: '' }));
                    }}
                  />
                  {error.first_name && <div className="invalid-feedback">{error.first_name}</div>}
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3">
                  <label className="form-label">Last Name<span className="text-danger px-1">*</span></label>
                  <input
                    // className="form-control"
                    className={`form-control ${error.last_name ? 'is-invalid' : ''}`}
                    type="text"
                    placeholder="Last Name"
                    value={selectedExpert.last_name}
                    onChange={(e) => {
                      setSelectedExpert(prev => ({ ...prev, last_name: e.target.value }));
                      setError((prev) => ({ ...prev, last_name: '' }));
                    }}
                  />
                  {error.last_name && <div className="invalid-feedback">{error.last_name}</div>}
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3">
                  <label className="form-label">Email<span className="text-danger px-1">*</span></label>
                  <input
                    className={`form-control ${error.email ? 'is-invalid' : ''}`}
                    type="email"
                    placeholder="Enter Email"
                    value={selectedExpert.email}
                    onChange={(e) => {
                      setSelectedExpert(prev => ({ ...prev, email: e.target.value }));
                      setError((prev) => ({ ...prev, email: '' }));
                    }}
                  />
                  {error.email && <div className="invalid-feedback">{error.email}</div>}
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3" >
                  <label className="form-label">Phone<span className="text-danger px-1">*</span></label>
                  <input
                    className={`form-control ${error.phone ? 'is-invalid' : ''}`}
                    type="text"
                    placeholder="Enter Phone number"
                    value={selectedExpert.phone}
                    onChange={(e) => {
                      setSelectedExpert(prev => ({ ...prev, phone: e.target.value }));
                      setError((prev) => ({ ...prev, phone: '' }));
                    }}
                  />
                  {error.phone && <div className="invalid-feedback">{error.phone}</div>}
                </div>
              </Col>

              <Col lg={6}>
                <div className="mb-3">
                  <label className="form-label">Country Code <span className="text-danger px-1">*</span></label>
                  <select
                    className={`form-control ${error.selectedCode ? 'is-invalid' : ''}`}
                    // value={timecode}
                    value={selectedCode}
                    onChange={(e) => {
                      handleCountryChange(e);
                      setError((prev) => ({ ...prev, selectedCode: '' }));
                    }}
                  >
                    <option value="">Please select country</option>
                    {/* {[...new Set(timezone.map((item) => item.code))].map((code) => (
                      <option key={code} value={code}>{code}</option>
                    ))} */}
                    {[...new Map(timezone.map(item => [item.code, item.country])).entries()].map(([code, country]) => (
                      <option key={code} value={code}>{country}</option>
                    ))}
                  </select>
                  {error.selectedCode && <div className="invalid-feedback">{error.selectedCode}</div>}
                </div>
              </Col>

              <Col lg={6}>
                <div className="mb-3">
                  <label className="form-label">Time Zone <span className="text-danger px-1">*</span></label>
                  <select
                    className={`form-control ${error.selectedTimezone ? 'is-invalid' : ''}`}
                    value={selectedTimezone}
                    disabled={selectedCode === ''}
                    onChange={(e) => {
                      handleTimezoneChange(e);
                      setError((prev) => ({ ...prev, selectedTimezone: '' }));
                    }}
                  >
                    <option value="">Please select timezone</option>
                    {filteredTimezones.map((tzItem) => (
                      <option key={tzItem.timezone} value={tzItem.timezone}>
                        {tzItem.timezone}
                        {/* {tzItem.timezone} ({tzItem.country}) */}
                      </option>
                    ))}
                  </select>
                  {error.selectedTimezone && <div className="invalid-feedback">{error.selectedTimezone}</div>}
                  {selectedCode === '' && <div className="text-info">Please select country code first</div>}
                </div>
              </Col>

              <Col lg={6}>
                <div className="mb-3">
                  <label className="form-label">Category<span className="text-danger px-1">*</span></label>
                  <select
                    // className="form-control" 
                    className={`form-control ${error.category ? 'is-invalid' : ''} text-capitalize`}
                    value={selectedExpert.category}
                    ref={selectRef}
                    onChange={(e) => {
                      handleCategoryChange(e);
                      setError((prev) => ({ ...prev, category: '' }));
                    }}
                  >
                    <option defaultChecked>Please select</option>
                    {categories.map((category) => (
                      <option key={category.id} value={category.name}>
                        {category.name}
                      </option>
                    ))}
                  </select>
                  {error.category && <div className="invalid-feedback">{error.category}</div>}
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3">
                  <label className="form-label">Sub Category<span className="text-danger px-1">*</span></label>
                  <select className={`form-control ${error.subcategory ? 'is-invalid' : ''} text-capitalize`} value={selectedExpert.subcategory} onChange={(e) => {
                    setSelectedExpert(prev => ({ ...prev, subcategory: e.target.value })); handleSubcategoryChange(e);
                    setError((prev) => ({ ...prev, subcategory: '' }))
                  }}
                  >
                    <option disabled>Please Select A Category</option>
                    {categories.filter((cat: any) => (cat.name == selectedExpert.category.toLowerCase()))[0]?.subcats?.map((subcat, index) => (
                      // {subcategories.map((subcat, index) => (
                      <option key={index} value={subcat.name}>
                        {subcat.name}
                      </option>
                    ))}
                  </select>
                  {error.subcategory && <div className="invalid-feedback">{error.subcategory}</div>}
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3">
                  <label className="form-label">Revenue Share Percentage (%)</label>
                  <input
                    className="form-control"
                    type="number"
                    min="0"
                    max="100"
                    step="0.01"
                    placeholder="0.00"
                    value={selectedExpert.share_percentage || 0}
                    onChange={(e) => {
                      const value = parseFloat(e.target.value) || 0;
                      setSelectedExpert(prev => ({ ...prev, share_percentage: value }));
                    }}
                  />
                  <small className="text-muted">Percentage of booking amount expert receives (0-100)</small>
                </div>
              </Col>
              <Col lg={12}>
                <div className="d-flex justify-content-end">
                  <button className="btn btn-primary mb-3" onClick={handleSave} >Add Expert</button>
                </div>
              </Col>
            </Row>
          </div>
        </Modal>


        <Modal
          isOpen={edit_modal_center}
          toggle={() => { editExpert(); }}
          backdrop={'static'}
          id="staticBackdrop"
          centered
          size="lg"
          className="rounded-4"
        >
          <ModalHeader className="py-3 px-4" toggle={() => { handleEditModalClose(); }}>
            <div className="modal-title mt-0 font-size-20 text-dark">Edit Expert</div>
          </ModalHeader>
          <div className="modal-body p-4">
            <Row>
              <Col lg={12}>
                <div className="mb-3 border-bottom pb-3 text-center">
                  <div className="text-center mb-2">
                    <div className="position-relative d-inline-block">
                      <div className="position-relative bottom-0 end-0">
                        <Label htmlFor="edit-project-image-input" className="mb-0 position-relative" id="editProjectImageInput">
                          <div className="avatar-xs imageChangeFloat">
                            <div className="avatar-title bg-light border rounded-circle text-muted cursor-pointer shadow font-size-16">
                              <i className="bx bxs-image-alt"></i>
                            </div>
                          </div>
                          <div className="avatar-lg">
                            <div className="avatar-title bg-light rounded-circle">
                              <img
                                src={selectedImage || defaultUserImg}
                                id="edit-projectlogo-img"
                                alt=""
                                className="avatar-md rounded-circle object-fit-cover"
                              />
                            </div>
                          </div>
                        </Label>
                        <input
                          className="form-control d-none"
                          id="edit-project-image-input"
                          type="file"
                          accept="image/png, image/gif, image/jpeg"
                          onChange={handleImageChangeo}
                        />
                      </div>

                    </div>
                  </div>
                  <Label className="form-label">Expert Image</Label>
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3">
                  <label className="form-label">First Name<span className="text-danger px-1">*</span></label>
                  <input
                    className={`form-control ${error.first_name ? 'is-invalid' : ''}`}
                    type="text"
                    placeholder="First Name"
                    value={selectedExpert.first_name}
                    onChange={(e) => {
                      setSelectedExpert(prev => ({ ...prev, first_name: e.target.value }));
                      setErrors((prev) => ({ ...prev, first_name: '' }));
                    }}
                  />
                  {error.first_name && <div className="invalid-feedback">{error.first_name}</div>}
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3">
                  <label className="form-label">Last Name<span className="text-danger px-1">*</span></label>
                  <input
                    className={`form-control ${error.last_name ? 'is-invalid' : ''}`}
                    type="text"
                    placeholder="Last Name"
                    value={selectedExpert.last_name}
                    onChange={(e) => {
                      setSelectedExpert(prev => ({ ...prev, last_name: e.target.value }));
                      setErrors((prev) => ({ ...prev, last_name: '' }));
                    }}
                  />
                  {error.last_name && <div className="invalid-feedback">{error.last_name}</div>}
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3">
                  <label className="form-label">Email<span className="text-danger px-1">*</span></label>
                  <input
                    className={`form-control ${error.email ? 'is-invalid' : ''}`}
                    type="email"
                    placeholder="Enter Email"
                    value={selectedExpert.email}
                    onChange={(e) => {
                      setSelectedExpert(prev => ({ ...prev, email: e.target.value }));
                      setErrors((prev) => ({ ...prev, email: '' }));
                    }}
                  />
                  {error.email && <div className="invalid-feedback">{error.email}</div>}
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3">
                  <label className="form-label">Phone<span className="text-danger px-1">*</span></label>
                  <input
                    className={`form-control ${error.phone ? 'is-invalid' : ''}`}
                    type="text"
                    placeholder="Enter Phone number"
                    value={selectedExpert.phone}
                    onChange={(e) => {
                      setSelectedExpert(prev => ({ ...prev, phone: e.target.value }));
                      setErrors((prev) => ({ ...prev, phone: '' }));
                    }}
                  />
                  {error.phone && <div className="invalid-feedback">{error.phone}</div>}
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3">
                  <label className="form-label">Country Code <span className="text-danger px-1">*</span></label>
                  <select
                    className={`form-control ${error.selectedCode ? 'is-invalid' : ''}`}
                    value={selectedExpert.timecode}
                    onChange={(e) => {
                      const selectedCode = e.target.value;
                      setSelectedExpert((prev) => ({ ...prev, timecode: selectedCode, timezone: '' }));
                      setSelectedCode(selectedCode);
                      const filtered = timezone.filter((item) => item.code === selectedCode);
                      setFilteredTimezones(filtered);
                      setSelectedTimezone('');
                      setErrors((prev) => ({ ...prev, selectedCode: '' }));
                    }}
                  >
                    <option value="">Please select country</option>
                    {/* {[...new Set(timezone.map((item) => item.code))].map((code) => (
                      <option key={code} value={code}>{code}</option>
                    ))} */}

                    {[...new Map(timezone.map(item => [item.code, item.country])).entries()].map(([code, country]) => (
                      <option key={code} value={code}>{country}</option>
                    ))}
                  </select>
                  {error.selectedCode && <div className="invalid-feedback">{error.selectedCode}</div>}
                </div>
              </Col>

              <Col lg={6}>
                <div className="mb-3">
                  <label className="form-label">Timezone<span className="text-danger px-1">*</span></label>
                  <select
                    className={`form-control ${error.selectedTimezone ? 'is-invalid' : ''}`}
                    value={selectedTimezone}
                    onChange={(e) => {
                      const tz = e.target.value;
                      setSelectedExpert((prev) => ({ ...prev, timezone: tz }));
                      setSelectedTimezone(tz);
                      setErrors((prev) => ({ ...prev, selectedTimezone: '' }));
                    }}
                    disabled={!selectedCode}
                  >
                    <option value="">Please select timezone</option>
                    {filteredTimezones.map((tzItem) => (
                      <option key={tzItem.timezone} value={tzItem.timezone}>
                        {/* {tzItem.timezone} ({tzItem.country}) */}
                        {tzItem.timezone}
                      </option>
                    ))}
                  </select>
                  {error.selectedTimezone && <div className="invalid-feedback">{error.selectedTimezone}</div>}
                </div>
              </Col>

              <Col lg={6}>
                <div className="mb-3">
                  <label className="form-label">Category<span className="text-danger px-1">*</span></label>
                  <select
                    className={`form-control ${error.category ? 'is-invalid' : ''}`}
                    value={selectedExpert.category?.toLowerCase()}
                    onChange={(e) => {
                      setSelectedExpert(prev => ({ ...prev, category: e.target.value }));
                      handleCategoryChange(e);
                      setErrors((prev) => ({ ...prev, category: '' }));
                    }}
                  >
                    {categories.map((category) => (
                      <option key={category.id} value={category.name}>
                        {category.name}
                      </option>
                    ))}
                  </select>
                  {error.category && <div className="invalid-feedback">{error.category}</div>}
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3">
                  <label className="form-label">Sub Category<span className="text-danger px-1">*</span></label>
                  <select
                    className={`form-control ${error.subcategory ? 'is-invalid' : ''}`}
                    value={selectedExpert.subcategory?.toLowerCase()}
                    onChange={(e) => {
                      setSelectedExpert(prev => ({ ...prev, subcategory: e.target.value }));
                      handleSubcategoryChange(e);
                      setErrors((prev) => ({ ...prev, subcategory: '' }));
                    }}
                  >
                    {categories.filter((cat: any) => (cat.name == selectedExpert.category.toLowerCase())).length > 0 ? categories.filter((cat: any) => (cat.name == selectedExpert.category.toLowerCase()))[0]?.subcats?.map((subcat, index) => (
                      // {subcategories.map((subcat, index) => (
                      <option key={index} value={subcat.name}>
                        {subcat.name}
                      </option>
                    )) : <option disabled>please select a category</option>}
                  </select>
                  {error.subcategory && <div className="invalid-feedback">{error.subcategory}</div>}
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3">
                  <label className="form-label">Revenue Share Percentage (%)</label>
                  <input
                    className="form-control"
                    type="number"
                    min="0"
                    max="100"
                    step="0.01"
                    placeholder="0.00"
                    value={selectedExpert.share_percentage || 0}
                    onChange={(e) => {
                      const value = parseFloat(e.target.value) || 0;
                      setSelectedExpert(prev => ({ ...prev, share_percentage: value }));
                    }}
                  />
                  <small className="text-muted">Percentage of booking amount expert receives (0-100)</small>
                </div>
              </Col>
              <Col lg={12}>
                <div className="d-flex justify-content-end">
                  <button className="btn btn-primary mb-3" onClick={handleSave}>
                    Update Expert
                  </button>
                </div>
              </Col>
            </Row>
          </div>
        </Modal>


        <Modal isOpen={modal_center_delete} toggle={() => { set_delete_delete(!modal_center_delete); }} centered className="rounded-4">
          <ModalHeader className="py-3 px-4" toggle={() => { set_delete_delete(!modal_center_delete); }}>
            <div className="modal-title mt-0 font-size-16 text-dark">Delete Expert</div>
          </ModalHeader>
          <div className="modal-body">
            <form>
              <div className="mb-3 px-2">
                <label htmlFor="message-text" className="col-form-label">
                  Are you sure you want to delete this expert?
                </label>
              </div>
            </form>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-soft-dark btn-sm" onClick={() => { set_delete_delete(false); }}>
              Cancel
            </button>
            <button type="button" className="btn btn-danger btn-sm" onClick={() => { handleConfirmDelete(); set_delete_delete(false); }}>
              Delete
            </button>
          </div>
        </Modal>

        {/* View Expert Modal */}
        <Modal
          isOpen={modal_view_expert}
          toggle={() => { closeViewExpert() }}
          size="lg"
          backdrop={'static'}
          centered
          className="rounded-4"
          onOpened={() => console.log("View Expert Modal opened")}
        >
          <ModalHeader className="py-3 px-4" toggle={() => { closeViewExpert() }}>
            <div className="modal-title mt-0 font-size-16 text-dark">
              Expert Details
            </div>
          </ModalHeader>
          <div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
            {selectedExpertForView ? (
              <>
                {/* Expert Card - Profile Picture and Details */}
                <Card className="mb-4">
                  <CardBody>
                    <Row className="align-items-center">
                      {/* Profile Picture */}
                      <Col lg={3} className="text-center mb-3 mb-lg-0">
                        <img
                          src={selectedExpertForView.user?.profile_pic ? `${process.env.REACT_APP_BASE_URL}${selectedExpertForView.user.profile_pic}` : defaultUserImg}
                          alt="Expert"
                          width="120"
                          height="120"
                          className="rounded-circle object-fit-cover border"
                          onError={(e) => {
                            const target = e.target as HTMLImageElement;
                            target.onerror = null;
                            target.src = defaultUserImg;
                          }}
                        />
                        {selectedExpertForView.business_logo && (
                          <div className="mt-3">
                            <img
                              src={`${process.env.REACT_APP_BASE_URL}${selectedExpertForView.business_logo}`}
                              alt="Business Logo"
                              width="80"
                              height="80"
                              className="rounded border"
                              onError={(e) => {
                                const target = e.target as HTMLImageElement;
                                target.onerror = null;
                                target.style.display = 'none';
                              }}
                            />
                            <div className="text-muted small mt-1">Business Logo</div>
                          </div>
                        )}
                      </Col>
                      
                      {/* Expert Details */}
                      <Col lg={9}>
                        <div className="mb-3">
                          <h5 className="mb-2">
                            {selectedExpertForView.user?.first_name || ''} {selectedExpertForView.user?.last_name || ''}
                            {selectedExpertForView.professional_title && (
                              <span className="text-muted ms-2">({selectedExpertForView.professional_title})</span>
                            )}
                          </h5>
                          
                          {selectedExpertForView.business_name && (
                            <div className="mb-2">
                              <div className="fw-medium">
                                <i className="bx bx-building me-2 text-muted"></i>
                                {selectedExpertForView.business_name}
                              </div>
                            </div>
                          )}
                          
                          {/* Email */}
                          <div className="mb-2">
                            <div className="fw-medium">
                              <i className="bx bx-envelope me-2 text-muted"></i>
                              {selectedExpertForView.user?.email || 'N/A'}
                            </div>
                          </div>
                          
                          {/* Phone */}
                          <div className="mb-2">
                            <div className="fw-medium">
                              <i className="bx bx-phone me-2 text-muted"></i>
                              {selectedExpertForView.user?.phone || 'N/A'}
                            </div>
                          </div>

                          {/* Business Phone */}
                          {selectedExpertForView.buissness_phone && (
                            <div className="mb-2">
                              <div className="fw-medium">
                                <i className="bx bx-phone-call me-2 text-muted"></i>
                                Business: {selectedExpertForView.buissness_phone}
                              </div>
                            </div>
                          )}
                          
                          {/* Category */}
                          <div className="mb-2">
                            <div className="d-flex flex-wrap gap-2 align-items-center">
                              <i className="bx bx-category me-1 text-muted"></i>
                              {selectedExpertForView.category?.name ? (
                                <>
                                  <span className="badge bg-primary">
                                    {selectedExpertForView.category.name}
                                  </span>
                                  {selectedExpertForView.subcategory?.name && (
                                    <span className="badge bg-info">
                                      {selectedExpertForView.subcategory.name}
                                    </span>
                                  )}
                                </>
                              ) : selectedExpertForView.basic_cat && selectedExpertForView.basic_cat.length > 0 ? (
                                <>
                                  <span className="badge bg-primary">
                                    {selectedExpertForView.basic_cat[0] ? selectedExpertForView.basic_cat[0].charAt(0).toUpperCase() + selectedExpertForView.basic_cat[0].slice(1).toLowerCase() : 'N/A'}
                                  </span>
                                  {selectedExpertForView.basic_cat[1] && (
                                    <span className="badge bg-info">
                                      {selectedExpertForView.basic_cat[1].charAt(0).toUpperCase() + selectedExpertForView.basic_cat[1].slice(1).toLowerCase()}
                                    </span>
                                  )}
                                </>
                              ) : (
                                <span className="text-muted">No category assigned</span>
                              )}
                            </div>
                          </div>
                          
                          {/* Timezone */}
                          {selectedExpertForView.timezone && (
                            <div className="mb-2">
                              <div className="fw-medium">
                                <i className="bx bx-time me-2 text-muted"></i>
                                {selectedExpertForView.timezone}
                              </div>
                            </div>
                          )}

                          {/* Country Code */}
                          {selectedExpertForView.country_code && (
                            <div className="mb-2">
                              <div className="fw-medium">
                                <i className="bx bx-globe me-2 text-muted"></i>
                                {selectedExpertForView.country_code}
                              </div>
                            </div>
                          )}

                          {/* Ratings */}
                          {selectedExpertForView.ratings !== undefined && selectedExpertForView.ratings !== null && (
                            <div className="mb-2">
                              <div className="fw-medium">
                                <i className="bx bx-star me-2 text-muted"></i>
                                {selectedExpertForView.ratings.toFixed(1)} / 5.0
                              </div>
                            </div>
                          )}

                          {/* Policy Time */}
                          {selectedExpertForView.policy_time && (
                            <div className="mb-2">
                              <div className="fw-medium">
                                <i className="bx bx-time-five me-2 text-muted"></i>
                                Policy Time: {selectedExpertForView.policy_time} hours
                              </div>
                            </div>
                          )}

                          {/* Status */}
                          <div className="mb-2">
                            <div className="fw-medium">
                              <i className="bx bx-check-circle me-2 text-muted"></i>
                              Status: 
                              <span className={`ms-2 ${selectedExpertForView.user?.is_active ? 'text-success' : 'text-danger'}`}>
                                {selectedExpertForView.user?.is_active ? 'Active' : 'Inactive'}
                              </span>
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>

                {/* Tabs Navigation */}
                <Nav tabs className="nav-tabs-custom mb-3">
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({ active: activeViewTab === "1" })}
                      onClick={() => { setActiveViewTab("1"); }}
                    >
                      Basic Information
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({ active: activeViewTab === "2" })}
                      onClick={() => { setActiveViewTab("2"); }}
                    >
                      Professional Details
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({ active: activeViewTab === "3" })}
                      onClick={() => { setActiveViewTab("3"); }}
                    >
                      Location & Contact
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({ active: activeViewTab === "4" })}
                      onClick={() => { setActiveViewTab("4"); }}
                    >
                      Online Presence
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({ active: activeViewTab === "5" })}
                      onClick={() => { setActiveViewTab("5"); }}
                    >
                      Additional Info
                    </NavLink>
                  </NavItem>
                </Nav>

                <TabContent activeTab={activeViewTab}>
                  {/* Basic Information Tab */}
                  <TabPane tabId="1">
                    <Row>
                      <Col lg={6} className="mb-3">
                        <div className="border-bottom pb-2">
                          <div className="fw-medium">Expert ID</div>
                          <small className="text-muted">{selectedExpertForView.id || 'N/A'}</small>
                        </div>
                      </Col>
                      {selectedExpertForView.created_at && (
                        <Col lg={6} className="mb-3">
                          <div className="border-bottom pb-2">
                            <div className="fw-medium">
                              {new Date(selectedExpertForView.created_at).toLocaleDateString()}
                            </div>
                            <small className="text-muted">Created At</small>
                          </div>
                        </Col>
                      )}
                      {selectedExpertForView.updated_at && (
                        <Col lg={6} className="mb-3">
                          <div className="border-bottom pb-2">
                            <div className="fw-medium">
                              {new Date(selectedExpertForView.updated_at).toLocaleDateString()}
                            </div>
                            <small className="text-muted">Updated At</small>
                          </div>
                        </Col>
                      )}
                      {selectedExpertForView.working_since && (
                        <Col lg={6} className="mb-3">
                          <div className="border-bottom pb-2">
                            <div className="fw-medium">{selectedExpertForView.working_since}</div>
                            <small className="text-muted">Working Since</small>
                          </div>
                        </Col>
                      )}
                      {selectedExpertForView.business_introduction && (
                        <Col lg={12} className="mb-3">
                          <div className="border-bottom pb-2">
                            <div className="fw-medium">{selectedExpertForView.business_introduction}</div>
                            <small className="text-muted">Business Introduction</small>
                          </div>
                        </Col>
                      )}
                    </Row>
                  </TabPane>

                  {/* Professional Details Tab */}
                  <TabPane tabId="2">
                    <Row>
                      {selectedExpertForView.certifications && (
                        <Col lg={12} className="mb-3">
                          <div className="border-bottom pb-2">
                            <div className="fw-medium">{selectedExpertForView.certifications}</div>
                            <small className="text-muted">Certifications</small>
                          </div>
                        </Col>
                      )}
                      {selectedExpertForView.licenses && (
                        <Col lg={12} className="mb-3">
                          <div className="border-bottom pb-2">
                            <div className="fw-medium">{selectedExpertForView.licenses}</div>
                            <small className="text-muted">Licenses</small>
                          </div>
                        </Col>
                      )}
                      {selectedExpertForView.education_background && (
                        <Col lg={12} className="mb-3">
                          <div className="border-bottom pb-2">
                            <div className="fw-medium">{selectedExpertForView.education_background}</div>
                            <small className="text-muted">Education Background</small>
                          </div>
                        </Col>
                      )}
                      {selectedExpertForView.years_of_experience && (
                        <Col lg={6} className="mb-3">
                          <div className="border-bottom pb-2">
                            <div className="fw-medium">{selectedExpertForView.years_of_experience} years</div>
                            <small className="text-muted">Years of Experience</small>
                          </div>
                        </Col>
                      )}
                      {selectedExpertForView.expertise_level && (
                        <Col lg={6} className="mb-3">
                          <div className="border-bottom pb-2">
                            <div className="fw-medium text-capitalize">{selectedExpertForView.expertise_level}</div>
                            <small className="text-muted">Expertise Level</small>
                          </div>
                        </Col>
                      )}
                      {selectedExpertForView.specializations && (
                        <Col lg={12} className="mb-3">
                          <div className="border-bottom pb-2">
                            <div className="fw-medium">{selectedExpertForView.specializations}</div>
                            <small className="text-muted">Specializations</small>
                          </div>
                        </Col>
                      )}
                      {selectedExpertForView.languages_spoken && (
                        <Col lg={12} className="mb-3">
                          <div className="border-bottom pb-2">
                            <div className="fw-medium">{selectedExpertForView.languages_spoken}</div>
                            <small className="text-muted">Languages Spoken</small>
                          </div>
                        </Col>
                      )}
                      {selectedExpertForView.tools && (
                        <Col lg={12} className="mb-3">
                          <div className="border-bottom pb-2">
                            <div className="fw-medium">{selectedExpertForView.tools}</div>
                            <small className="text-muted">Professional Tools</small>
                          </div>
                        </Col>
                      )}
                      {selectedExpertForView.client_types && (
                        <Col lg={12} className="mb-3">
                          <div className="border-bottom pb-2">
                            <div className="fw-medium">{selectedExpertForView.client_types}</div>
                            <small className="text-muted">Client Types</small>
                          </div>
                        </Col>
                      )}
                      {selectedExpertForView.industry_experience && (
                        <Col lg={12} className="mb-3">
                          <div className="border-bottom pb-2">
                            <div className="fw-medium">{selectedExpertForView.industry_experience}</div>
                            <small className="text-muted">Industry Experience</small>
                          </div>
                        </Col>
                      )}
                      {selectedExpertForView.skills && selectedExpertForView.skills.length > 0 && (
                        <Col lg={12} className="mb-3">
                          <div className="border-bottom pb-2">
                            <div className="d-flex flex-wrap gap-2">
                              {selectedExpertForView.skills.map((skill: any, index: number) => (
                                <span key={index} className="badge bg-secondary">
                                  {skill.name || skill}
                                </span>
                              ))}
                            </div>
                            <small className="text-muted">Skills</small>
                          </div>
                        </Col>
                      )}
                    </Row>
                  </TabPane>

                  {/* Location & Contact Tab */}
                  <TabPane tabId="3">
                    <Row>
                      {selectedExpertForView.address_line1 && (
                        <Col lg={12} className="mb-3">
                          <div className="border-bottom pb-2">
                            <div className="fw-medium">{selectedExpertForView.address_line1}</div>
                            <small className="text-muted">Address Line 1</small>
                          </div>
                        </Col>
                      )}
                      {selectedExpertForView.address_line2 && (
                        <Col lg={12} className="mb-3">
                          <div className="border-bottom pb-2">
                            <div className="fw-medium">{selectedExpertForView.address_line2}</div>
                            <small className="text-muted">Address Line 2</small>
                          </div>
                        </Col>
                      )}
                      {(selectedExpertForView.city || selectedExpertForView.state || selectedExpertForView.zipcode || selectedExpertForView.country) && (
                        <Col lg={12} className="mb-3">
                          <div className="border-bottom pb-2">
                            <div className="fw-medium">
                              {[
                                selectedExpertForView.city,
                                selectedExpertForView.state,
                                selectedExpertForView.zipcode,
                                selectedExpertForView.country
                              ].filter(Boolean).join(', ') || 'N/A'}
                            </div>
                            <small className="text-muted">City, State, ZIP, Country</small>
                          </div>
                        </Col>
                      )}
                      {selectedExpertForView.service_areas && (
                        <Col lg={12} className="mb-3">
                          <div className="border-bottom pb-2">
                            <div className="fw-medium">{selectedExpertForView.service_areas}</div>
                            <small className="text-muted">Service Areas</small>
                          </div>
                        </Col>
                      )}
                    </Row>
                  </TabPane>

                  {/* Online Presence Tab */}
                  <TabPane tabId="4">
                    <Row>
                      {selectedExpertForView.website && (
                        <Col lg={12} className="mb-3">
                          <div className="border-bottom pb-2">
                            <div className="fw-medium">
                              <a href={selectedExpertForView.website} target="_blank" rel="noopener noreferrer" className="text-primary">
                                {selectedExpertForView.website} <i className="bx bx-link-external"></i>
                              </a>
                            </div>
                            <small className="text-muted">Website</small>
                          </div>
                        </Col>
                      )}
                      {selectedExpertForView.linkedin_url && (
                        <Col lg={6} className="mb-3">
                          <div className="border-bottom pb-2">
                            <div className="fw-medium">
                              <a href={selectedExpertForView.linkedin_url} target="_blank" rel="noopener noreferrer" className="text-primary">
                                View Profile <i className="bx bx-link-external"></i>
                              </a>
                            </div>
                            <small className="text-muted">LinkedIn</small>
                          </div>
                        </Col>
                      )}
                      {selectedExpertForView.facebook_url && (
                        <Col lg={6} className="mb-3">
                          <div className="border-bottom pb-2">
                            <div className="fw-medium">
                              <a href={selectedExpertForView.facebook_url} target="_blank" rel="noopener noreferrer" className="text-primary">
                                View Page <i className="bx bx-link-external"></i>
                              </a>
                            </div>
                            <small className="text-muted">Facebook</small>
                          </div>
                        </Col>
                      )}
                      {selectedExpertForView.x_url && (
                        <Col lg={6} className="mb-3">
                          <div className="border-bottom pb-2">
                            <div className="fw-medium">
                              <a href={selectedExpertForView.x_url} target="_blank" rel="noopener noreferrer" className="text-primary">
                                View Profile <i className="bx bx-link-external"></i>
                              </a>
                            </div>
                            <small className="text-muted">X (Twitter)</small>
                          </div>
                        </Col>
                      )}
                      {selectedExpertForView.instagram_url && (
                        <Col lg={6} className="mb-3">
                          <div className="border-bottom pb-2">
                            <div className="fw-medium">
                              <a href={selectedExpertForView.instagram_url} target="_blank" rel="noopener noreferrer" className="text-primary">
                                View Profile <i className="bx bx-link-external"></i>
                              </a>
                            </div>
                            <small className="text-muted">Instagram</small>
                          </div>
                        </Col>
                      )}
                      {selectedExpertForView.youtube_url && (
                        <Col lg={6} className="mb-3">
                          <div className="border-bottom pb-2">
                            <div className="fw-medium">
                              <a href={selectedExpertForView.youtube_url} target="_blank" rel="noopener noreferrer" className="text-primary">
                                View Channel <i className="bx bx-link-external"></i>
                              </a>
                            </div>
                            <small className="text-muted">YouTube</small>
                          </div>
                        </Col>
                      )}
                      {selectedExpertForView.professional_blog && (
                        <Col lg={6} className="mb-3">
                          <div className="border-bottom pb-2">
                            <div className="fw-medium">
                              <a href={selectedExpertForView.professional_blog} target="_blank" rel="noopener noreferrer" className="text-primary">
                                View Blog <i className="bx bx-link-external"></i>
                              </a>
                            </div>
                            <small className="text-muted">Professional Blog</small>
                          </div>
                        </Col>
                      )}
                      {selectedExpertForView.portfolio_url && (
                        <Col lg={6} className="mb-3">
                          <div className="border-bottom pb-2">
                            <div className="fw-medium">
                              <a href={selectedExpertForView.portfolio_url} target="_blank" rel="noopener noreferrer" className="text-primary">
                                View Portfolio <i className="bx bx-link-external"></i>
                              </a>
                            </div>
                            <small className="text-muted">Portfolio</small>
                          </div>
                        </Col>
                      )}
                      {selectedExpertForView.profile_video && (
                        <Col lg={12} className="mb-3">
                          <div className="border-bottom pb-2">
                            <div className="fw-medium">
                              <a href={selectedExpertForView.profile_video} target="_blank" rel="noopener noreferrer" className="text-primary">
                                Watch Video <i className="bx bx-link-external"></i>
                              </a>
                            </div>
                            <small className="text-muted">Profile Video</small>
                          </div>
                        </Col>
                      )}
                    </Row>
                  </TabPane>

                  {/* Additional Info Tab */}
                  <TabPane tabId="5">
                    <Row>
                      {selectedExpertForView.case_studies && (
                        <Col lg={12} className="mb-3">
                          <div className="border-bottom pb-2">
                            <div className="fw-medium">{selectedExpertForView.case_studies}</div>
                            <small className="text-muted">Case Studies</small>
                          </div>
                        </Col>
                      )}
                      {selectedExpertForView.expert_tags && (
                        <Col lg={12} className="mb-3">
                          <div className="border-bottom pb-2">
                            <div className="d-flex flex-wrap gap-2">
                              {selectedExpertForView.expert_tags.split(',').map((tag: string, index: number) => (
                                <span key={index} className="badge bg-info">
                                  {tag.trim()}
                                </span>
                              ))}
                            </div>
                            <small className="text-muted">Expert Tags</small>
                          </div>
                        </Col>
                      )}
                      {selectedExpertForView.resume && (
                        <Col lg={12} className="mb-3">
                          <div className="border-bottom pb-2">
                            <div className="fw-medium">
                              <a href={`${process.env.REACT_APP_BASE_URL}${selectedExpertForView.resume}`} target="_blank" rel="noopener noreferrer" className="text-primary">
                                View Resume <i className="bx bx-link-external"></i>
                              </a>
                            </div>
                            <small className="text-muted">Resume</small>
                          </div>
                        </Col>
                      )}
                      {selectedExpertForView.packs && selectedExpertForView.packs.length > 0 && (
                        <Col lg={12} className="mb-3">
                          <div className="border-bottom pb-2">
                            <div>
                              {selectedExpertForView.packs.map((pack: any, index: number) => (
                                <div key={index} className="mb-2">
                                  <div className="fw-medium">{pack.name || pack.title || `Package ${index + 1}`}</div>
                                  {pack.price && <div className="text-muted">${pack.price}</div>}
                                  {pack.session_mins && <div className="text-muted">{pack.session_mins} minutes</div>}
                                </div>
                              ))}
                            </div>
                            <small className="text-muted">Packages</small>
                          </div>
                        </Col>
                      )}
                      {selectedExpertForView.availabilty && Object.keys(selectedExpertForView.availabilty).length > 0 && (
                        <Col lg={12} className="mb-3">
                          <div className="border-bottom pb-2">
                            <div>
                              {Object.entries(selectedExpertForView.availabilty).map(([date, hours]: [string, any]) => (
                                <div key={date} className="mb-2">
                                  <div className="fw-medium">{date}</div>
                                  <div className="text-muted">Hours: {Array.isArray(hours) ? hours.join(', ') : hours}</div>
                                </div>
                              ))}
                            </div>
                            <small className="text-muted">Availability</small>
                          </div>
                        </Col>
                      )}
                    </Row>
                  </TabPane>
                </TabContent>
              </>
            ) : (
              <div className="text-center py-4">
                <p className="text-muted">Loading expert details...</p>
              </div>
            )}
          </div>
          <div className="modal-footer">
            <button 
              type="button" 
              className="btn btn-sm btn-primary" 
              onClick={() => { closeViewExpert() }}
            >
              Close
            </button>
          </div>
        </Modal>
      </div>
    </div>
  );
}
export default Cbookings;